<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading" :is-full-screen="true" />
                <section class="card p-1 pt-0">
                    <div>   <div class="row floating_pointview_container">
                            <div class="auto mr-1">
                                <div class="maproute_text">
                                    Map Route
                                </div>
                            </div>
                                <div class="w-auto">
                                    <div class="floating_pointview" id="floating-panel">
                                        <div class="start_maptxtone">
                                            <b>Start: </b>
                                            <select id="start">
                                                <option value="pune, India">PNQO</option>
                                            </select>
                                        </div>
                                        
                                        <div class="start_maptxtone">
                                        <b>End: </b>
                                        <select id="end">
                                            <!-- <option value="Mumbai, India">Mumbai</option> -->
                                            <option value="28.4829357, 76.81108454">DELH</option>
                                            <option value="30.20227746, 76.87500926">AMCO</option>
                                            <option value="22.83677573, 86.23336711">JSPO</option>
                                            <option value="19.32838749, 73.1034658">BOMD</option>
                                            <option value="19.32861431, 73.10352915">BWD</option>
                                            <option value="15.32081099, 75.10942451">BGM</option>
                                            <option value="15.32081099, 75.10942451">HBL</option>
                                            <option value="20.3252149, 72.90557776">VPI</option>
                                            <option value="22.398839, 73.137974">BDQN</option>
                                            <option value="22.92808983, 72.44836951">AMDI</option>
                                            <option value="22.76154221, 88.31523491">CCUO</option>
                                            <option value="22.76154221, 88.31523491">PATO</option>
                                            <option value="21.13866742, 78.90309435">NAGO</option>
                                            <option value="21.27997639, 81.60997476">RPR</option>
                                            <option value="17.528655, 78.441097">HYDO</option>
                                            <option value="12.75143254, 77.73542494">BLRO</option>
                                            <option value="11.62699, 78.13533">SLMO</option>
                                            <option value="13.04071433,80.02772123">MAAO</option>
                                        </select> 
                                    </div>
                                    </div>
                                </div>
                            </div>
                        <div id="map"></div>
                        <div id="warnings-panel"></div>
                        <div ref="mapContainer" style="height: calc(100vh - 170px)"></div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"
import * as VueGoogleMaps from 'vue2-google-maps';

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg',
//     libraries: 'places', // If needed
//   },
// });
export default ({
    name: 'MapCluster',
    mixins: [common_methods, searchMasterNameList],
    components: {
        VueElementLoading,
    },
    data() {
        return {
            isLoading: false,
            map: null,
            directionsService: null,
            directionsRenderer: null,
            routes: [],
        }
    },
    mounted() {
        this.getRoutes()
        this.loadGoogleMapsScript().then(() => {
            this.initMap();
        });

        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
    },
    methods: {
        getRoutes() {
            this.searchNameMasterList('route_details', 'route_path', null, 'route_path')
                .then(result => {
                    this.routes = result.data
                    console.log(this.routes)
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDhJQ2sy_EA-1Cin40Hsxph0uKHfDCT_ko`;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        initMap() {
            console.log("2222");
            this.markerArray = [];

            this.directionsService = new window.google.maps.DirectionsService();

            this.map = new window.google.maps.Map(this.$refs.mapContainer, {
                center: { lat: 18.5204, lng: 73.8567},
                zoom: 13,
            });
            this.directionsRenderer = new window.google.maps.DirectionsRenderer({ map: this.map });
            this.stepDisplay = new window.google.maps.InfoWindow();
            this.calculateAndDisplayRoute(
                this.directionsRenderer,
                this.directionsService,
                // this.markerArray,
                this.stepDisplay,
                this.map,
            );

            // Listen to change events from the start and end lists.


            document.getElementById("start").addEventListener("change", this.onChangeHandler);
            document.getElementById("end").addEventListener("change", this.onChangeHandler);

            // this.directionsRenderer.setMap(this.map);
        },
        onChangeHandler() {
                console.log("on change");
                this.calculateAndDisplayRoute(
                    this.directionsRenderer,
                    this.directionsService,
                    // this.markerArray,
                    this.stepDisplay,
                    this.map,
                );
            },

        calculateAndDisplayRoute(directionsRenderer, directionsService, markerArray,stepDisplay, map) {
            // First, remove any existing markers from the map.
            for (let i = 0; i < markerArray.length; i++) {
                markerArray[i].setMap(null);
            }

            // Retrieve the start and end locations and create a DirectionsRequest using
            // WALKING directions.
            directionsService.route({
                    origin: document.getElementById("start").value,
                    destination: document.getElementById("end").value,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                })
                .then((result) => {
                // Route the directions and pass the response to a function to create
                // markers for each step.
                document.getElementById("warnings-panel").innerHTML =
                    "<b>" + result.routes[0].warnings + "</b>";
                directionsRenderer.setDirections(result);
                this.showSteps(result, markerArray, stepDisplay, map);
                })
                .catch((e) => {
                    window.alert("Directions request failed due to " + e);
                });
        },
        showSteps(directionResult, markerArray, stepDisplay, map) {
            // For each step, place a marker, and add the text to the marker's infowindow.
            // Also attach the marker to an array so we can keep track of it and remove it
            // when calculating new routes.
            const myRoute = directionResult.routes[0].legs[0];

            for (let i = 0; i < myRoute.steps.length; i++) {
                const marker = (markerArray[i] =
                markerArray[i] || new window.google.maps.Marker());

                marker.setMap(map);
                marker.setPosition(myRoute.steps[i].start_location);
                this.attachInstructionText(stepDisplay,marker,myRoute.steps[i].instructions,map);
            }
        },
        attachInstructionText(stepDisplay, marker, text, map) {
            window.google.maps.event.addListener(marker, "click", () => {
                // Open an info window when the marker is clicked on, containing the text
                // of the step.
                stepDisplay.setContent(text);
                stepDisplay.open(map, marker);
            });
        }
    },
})
</script>

<style scoped>
 #map {
  height: 100%;
}
.start_maptxtone select{
    border: 1px solid #d5d5d5!important;
    outline: none;
    background: #fff;
    box-shadow: none!important;
    border-radius: 2px;
    padding: 4px 10px
}
.floating_pointview_container{
   
    padding: 7px;
    margin: 0px;
    border-radius: 2px;
    margin-bottom: 4px;
    box-shadow: none;
    padding-top: 0px;
}
.floating_pointview b{
    margin: 5px 15px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.3px;
}
.maproute_text{
    padding: 7px 0px;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.3px;
}
.floating_pointview .start_maptxtone{
    display: inline-block;
    padding: 6px 5px;
}

.floating_pointview{
    padding: 0px 10px;
    box-shadow: none;
    border-radius: 5px;
}
#warnings-panel {
  width: 100%;
  height: 10%;
  text-align: center;
}
</style>